<template>
  <div class="home">
    <Introduction />
    <Projects />
    <Awards />
    <Brands />
    <!-- <Contact /> -->
    <Footer />
  </div>
</template>

<script>

import VueScrollTo from 'vue-scrollto';
import Introduction from '@/components/Introduction.vue';
import Projects from '@/components/Projects.vue';
import Awards from '@/components/Awards.vue';
import Brands from '@/components/Brands.vue';
import Contact from '@/components/Contact.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Home',
  components: {
    Introduction,
    Projects,
    Awards,
    Brands,
    Contact,
    Footer,
  },
  methods: {
  },
  async mounted() {
    await await this.$store.dispatch('UPDATE_HOMESECTIONS');
    const cancelScroll = VueScrollTo.scrollTo('#app');
  },
};
</script>
